/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_CS_CZ: Record<string, string> = {
    ariaAnnounceChart: 'graf, ${seriesCount}[number] sérií',
    ariaAnnounceFlowProportionLink: 'odkaz ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'uzel ${index} z ${count}, ${description}',
    ariaAnnounceGaugeChart: 'graf měřidla, ${caption}',
    ariaAnnounceHierarchyChart: 'hierarchický graf, ${caption}',
    ariaAnnounceHierarchyDatum: 'úroveň ${level}[number], ${count}[number] děti, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Stiskněte mezerník nebo Enter pro přepnutí viditelnosti',
    ariaLabelAddHorizontalLine: 'Přidat vodorovnou čáru',
    ariaLabelAnnotationOptionsToolbar: 'Možnosti anotace',
    ariaLabelAnnotationSettingsDialog: 'Nastavení anotace',
    ariaLabelColorPicker: 'Výběr barev',
    ariaLabelFinancialCharts: 'Finanční grafy',
    ariaLabelLegend: 'Legenda',
    ariaLabelLegendItem: '${label}, položka legendy ${index}[number] z ${count}[number]',
    ariaLabelLegendItemUnknown: 'Neznámá položka legendy',
    ariaLabelLegendPageNext: 'Další stránka legendy',
    ariaLabelLegendPagePrevious: 'Předchozí stránka legendy',
    ariaLabelLegendPagination: 'Stránkování legendy',
    ariaLabelNavigator: 'Navigátor',
    ariaLabelNavigatorMaximum: 'Maximum',
    ariaLabelNavigatorMinimum: 'Minimální',
    ariaLabelNavigatorRange: 'Rozsah',
    ariaLabelRangesToolbar: 'Rozsahy',
    ariaLabelSettingsTabBar: 'Nastavení',
    ariaLabelZoomToolbar: 'Přiblížit',
    ariaValuePanRange: '${min}[percent0to2dp] až ${max}[percent0to2dp]',
    contextMenuDownload: 'Stáhnout',
    contextMenuPanToCursor: 'Posunout sem',
    contextMenuToggleOtherSeries: 'Přepnout ostatní série',
    contextMenuToggleSeriesVisibility: 'Přepnout viditelnost',
    contextMenuZoomToCursor: 'Přiblížit sem',
    dialogHeaderChannel: 'Kanál',
    dialogHeaderDatePriceRange: 'Datum a cena',
    dialogHeaderDateRange: 'Časové období',
    dialogHeaderFibonacciRange: 'Fib Retracement',
    dialogHeaderLine: 'Čára',
    dialogHeaderPriceRange: 'Cenové rozmezí',
    dialogHeaderText: 'Text',
    dialogInputAlign: 'Zarovnat',
    dialogInputColorPicker: 'Barva',
    dialogInputColorPickerAltText: 'Barva textu',
    dialogInputExtendAbove: 'Rozšířit nad',
    dialogInputExtendBelow: 'Rozšířit dolů',
    dialogInputExtendChannelEnd: 'Rozšířit konec kanálu',
    dialogInputExtendChannelStart: 'Rozšířit začátek kanálu',
    dialogInputExtendLeft: 'Roztáhnout doleva',
    dialogInputExtendLineEnd: 'Prodlužte konec řádku',
    dialogInputExtendLineStart: 'Rozšířit začátek čáry',
    dialogInputExtendRight: 'Rozšířit doprava',
    dialogInputFibonacciBands: 'Pásma',
    dialogInputFibonacciBandsAltText: 'Fibonacci pásma',
    dialogInputFillColorPicker: 'Výplň',
    dialogInputFillColorPickerAltText: 'Barva výplně',
    dialogInputFontSize: 'Velikost',
    dialogInputFontSizeAltText: 'Velikost písma',
    dialogInputLineStyle: 'Čárkovaná čára',
    dialogInputPosition: 'Umístění',
    dialogInputReverse: 'Obrátit',
    dialogInputShowFill: 'Zobrazit výplň',
    dialogInputStrokeWidth: 'Tloušťka',
    dialogInputStrokeWidthAltText: 'Tloušťka čáry',
    iconAltTextAlignCenter: 'Zarovnat doprostřed',
    iconAltTextAlignLeft: 'Vlevo',
    iconAltTextAlignRight: 'Vpravo',
    iconAltTextClose: 'Zavřít',
    iconAltTextLineStyleDashed: 'Dlouhé pomlčky',
    iconAltTextLineStyleDotted: 'Krátké čárkované',
    iconAltTextLineStyleSolid: 'Plná',
    iconAltTextPositionBottom: 'Dole',
    iconAltTextPositionCenter: 'Střed',
    iconAltTextPositionTop: 'Nahoru',
    inputTextareaPlaceholder: 'Přidat text',
    measurerDateRangeBars: '${value}[number] pruhy',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Objem ${value}',
    overlayLoadingData: 'Načítání dat...',
    overlayNoData: 'Žádná data k zobrazení',
    overlayNoVisibleSeries: 'Žádná viditelná série',
    overlayUnsupportedBrowser: 'Nepodporovaná verze prohlížeče. Prosím, aktualizujte si prohlížeč.',
    seriesHistogramTooltipCount: '${yName} (počet)',
    seriesHistogramTooltipFrequency: 'Frekvence',
    seriesHistogramTooltipMean: '${yName} (průměr)',
    seriesHistogramTooltipSum: '${yName} (součet)',
    toolbarAnnotationsArrow: 'Šipka',
    toolbarAnnotationsArrowDown: 'Šipka dolů',
    toolbarAnnotationsArrowUp: 'Šipka nahoru',
    toolbarAnnotationsCallout: 'Poznámka pod čarou',
    toolbarAnnotationsClearAll: 'Vymazat vše',
    toolbarAnnotationsComment: 'Komentář',
    toolbarAnnotationsDatePriceRange: 'Datum a cena',
    toolbarAnnotationsDateRange: 'Časový rozsah',
    toolbarAnnotationsDelete: 'Smazat',
    toolbarAnnotationsDisjointChannel: 'Oddělený kanál',
    toolbarAnnotationsDragHandle: 'Přetáhněte panel nástrojů',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Výpočet Fibonacciho korekcí',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib Trend Nezávislý na Čase',
    toolbarAnnotationsFillColor: 'Barva výplně',
    toolbarAnnotationsHorizontalLine: 'Horizontální čára',
    toolbarAnnotationsLineAnnotations: 'Trendy linie',
    toolbarAnnotationsLineColor: 'Barva čáry',
    toolbarAnnotationsLineStrokeWidth: 'Šířka tahu čáry',
    toolbarAnnotationsLineStyle: 'Styl čáry',
    toolbarAnnotationsLock: 'Zamknout',
    toolbarAnnotationsMeasurerAnnotations: 'Měřiče',
    toolbarAnnotationsNote: 'Poznámka',
    toolbarAnnotationsParallelChannel: 'Paralelní kanál',
    toolbarAnnotationsPriceRange: 'Cenové rozpětí',
    toolbarAnnotationsQuickDatePriceRange: 'Měřit',
    toolbarAnnotationsSettings: 'Nastavení',
    toolbarAnnotationsShapeAnnotations: 'Šipky',
    toolbarAnnotationsText: 'Text',
    toolbarAnnotationsTextAnnotations: 'Textové poznámky',
    toolbarAnnotationsTextColor: 'Barva textu',
    toolbarAnnotationsTextSize: 'Velikost textu',
    toolbarAnnotationsTrendLine: 'Trend Line',
    toolbarAnnotationsUnlock: 'Odemknout',
    toolbarAnnotationsVerticalLine: 'Vertikální čára',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 měsíc',
    toolbarRange1Year: '1R',
    toolbarRange1YearAria: '1 rok',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 měsíce',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 měsíců',
    toolbarRangeAll: 'Vše',
    toolbarRangeAllAria: 'Vše',
    toolbarRangeYearToDate: 'Rok do dnešního dne',
    toolbarRangeYearToDateAria: 'Od začátku roku',
    toolbarSeriesTypeCandles: 'Svíčky',
    toolbarSeriesTypeDropdown: 'Typ grafu',
    toolbarSeriesTypeHighLow: 'Výška Nízká',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Průsvitné svíčky',
    toolbarSeriesTypeLine: 'Čára',
    toolbarSeriesTypeLineWithMarkers: 'Čára s markery',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Kroková Čára',
    toolbarZoomPanEnd: 'Posunout na konec',
    toolbarZoomPanLeft: 'Posunout vlevo',
    toolbarZoomPanRight: 'Posunout doprava',
    toolbarZoomPanStart: 'Posunout na začátek',
    toolbarZoomReset: 'Obnovit zoom',
    toolbarZoomZoomIn: 'Přiblížit',
    toolbarZoomZoomOut: 'Oddálit',
    tooltipPaginationStatus: '${index}[number] z ${count}[number]',
};
